/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: "/admin",
    view: "Admin"
  },
  {
    path: "/agrounit",
    view: "AgroUnit"
  },
  {
    path: "/Ayuda",
    view: "Ayuda"
  },
  {
    path: "/Dashboard",
    // name: "Dashboard",
    view: "Dashboard",
    // alias: '/nxtagro'
  },
  {
    path: "/device",
    view: "Device"
  },

  {
    path: "/CargarPlagas",
    // name: "CargarPlagas",
    view: "CargarPlagas",
  },
  {
    path: "/CE",
    view: "CE"
  },
  {
    path: "/company",
    view: "Company"
  },
  {
    path: "/configuracion",
    view: "Configuracion"
  },
  {
    path: "/Clima",
    // name: "Clima",
    view: "Clima",
  },
  {
    path: "/forecast",
    view: "Forecast",
  },
  {
    path: "/PlagasEnfermedades",
    // name: "PlagasEnfermedades",
    view: "PlagasEnfermedades",
  },

  {
    path: "/geofence",
    view: "Geofence"
  },


  {
    path: "/icons",
    view: "Icons",
  },

  {
    path: "/InstruccionRiego",
    view: "InstruccionRiego"
  },

  {
    path: "/Notificaciones",
    view: "Notificaciones",
  },
  {
    path: "/ReportesDiarios",
    view: "ReportesDiarios",
  },
  {
    path: "/ReportesPlagas",
    // name: "ReportesPlagas",
    view: "ReportesPlagas",
  },
  {
    path: "/signin",
    name: "signin",
    view: "SignIn",
  },
  {
    path: "/signup",
    view: "SignUp"
  },

  {
    path: "/PH",
    view: "PH"
  },
  {
    path: "/project",
    view: "Project"
  },
  {
    path: "/subproject",
    view: "SubProject"
  },
  {
    path: "/typography",
    view: "Typography",
  },

  {
    path: "/tunel",
    view: "Tunel"
  },
  {
    path: "/Sodio",
    view: "Sodio"
  },

  {
    path: "/Sensores",
    view: "Sensores"
  },
  {
    path: "/Humidity",
    view: "Humidity"
  },

  {
    path: "/user-profile",
    // name: "User Profile",
    view: "UserProfile",
  },

];
